'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    cdnRoot: 'http://api.caligram.local',
    googleMapsAPIKey: process.env.GOOGLE_MAPS_API_KEY,
    isProduction: false
  },
  staging: {
    cdnRoot: 'https://cdn.caligram.com',
    googleMapsAPIKey: process.env.GOOGLE_MAPS_API_KEY,
    isProduction: true
  },
  production: {
    cdnRoot: 'https://cdn.caligram.com',
    googleMapsAPIKey: process.env.GOOGLE_MAPS_API_KEY,
    isProduction: true,
    fullStoryOrgId: 'N9XPY'
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  port: process.env.PORT,
  api: {
    url: '/api'
  },
  app: {
    name: 'Caligram Admin',
    description: "L'interface d’administration de Caligram",
    meta: {
      charSet: 'utf-8',
      property: {
        'og:site_name': 'Caligram',
        'og:image': 'http://api.caligram.com/logo.png',
        'og:locale': 'fr_CA',
        'og:title': 'Caligram',
        'og:description': "L'interface d’administration de Caligram",
        'twitter:card': 'summary',
        'twitter:site': '@coopterritoires',
        'twitter:creator': '@coopterritoires',
        'twitter:title': 'Caligram',
        'twitter:description': "L'interface d’administration de Caligram",
        'twitter:image': 'http://api.caligram.com/logo.png',
        'twitter:image:width': '232',
        'twitter:image:height': '58'
      }
    }
  },
  cache: {
    oneDay: '86400'
  }
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 260
// module chunks = 0